"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMRole = void 0;
var EMRole;
(function (EMRole) {
    EMRole["EM"] = "EM";
    EMRole["LEAD_EM"] = "EM Lead";
    EMRole["EM_MANAGER"] = "EM Manager";
    EMRole["SENIOR_EM_MANAGER"] = "Senior EM Manager";
    EMRole["DIRECTOR"] = "Director";
})(EMRole || (exports.EMRole = EMRole = {}));
//# sourceMappingURL=EMRole.js.map